import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum FinanceSecurityRight {
    CanAccessPurchaseOrder = 10000,
    ManagePurchaseOrder = 10001,
    ProcessingPurchaseOrder = 10002,
    ApprovePurchaseOrder = 10003,

    CanAccessPending = 2000,
    CanAccessBills = 2100,
    CanAccessInvoices = 2200,
    ManageInvoices = 2001,
    ManageBills = 2002,
    ManagePayments = 2003,

    ManageApprovedInvoices = 2004,
    ManageApprovedBills = 2005,

    CanAccessPayments = 27000,
    DeletePayment = 27002,

    CanCreatePaymentViews = 27010,
    ManageOtherUsersPaymentViews = 27011,

    CanAccessSaleOrder = 27100,
    /** Write/create/convert/cancel Sales Orders (alongside CanAccessSaleOrder for reads). */
    ManageSaleOrder = 27101,
}

export class FinanceSecurityModule extends BaseSecurityModule<FinanceSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Finance,
            [
                { _id: FinanceSecurityRight.CanAccessPending, name: 'Access Pending', basic: true },
                { _id: FinanceSecurityRight.CanAccessBills, name: 'Access Bills', basic: true },
                { _id: FinanceSecurityRight.CanAccessInvoices, name: 'Access Invoices', basic: true },
                { _id: FinanceSecurityRight.CanAccessPayments, name: 'Access Payments', basic: true },
                { _id: FinanceSecurityRight.CanAccessSaleOrder, name: 'Access Sale Order', basic: true },
                { _id: FinanceSecurityRight.CanAccessPurchaseOrder, name: 'Access Purchase Order', basic: true },



                { _id: FinanceSecurityRight.ManageBills, name: 'Manage Bills', basic: false },
                { _id: FinanceSecurityRight.ManageInvoices, name: 'Manage Invoices', basic: false },
                { _id: FinanceSecurityRight.ManageApprovedBills, name: 'Manage Approved Bills', basic: false },
                { _id: FinanceSecurityRight.ManageApprovedInvoices, name: 'Manage Approved Invoices', basic: false },
                { _id: FinanceSecurityRight.ManagePurchaseOrder, name: 'Manage Purchase Order', basic: false },
                { _id: FinanceSecurityRight.ManageSaleOrder, name: 'Manage Sale Order', basic: false },
                { _id: FinanceSecurityRight.ManagePayments, name: 'Manage Payments', basic: false },
                { _id: FinanceSecurityRight.DeletePayment, name: 'Delete Payments', basic: false },
                { _id: FinanceSecurityRight.CanCreatePaymentViews, name: 'Can Create Payment Views', basic: false },
                { _id: FinanceSecurityRight.ManageOtherUsersPaymentViews, name: 'Can Manage Other User Payment Views', basic: false },
                { _id: FinanceSecurityRight.ProcessingPurchaseOrder, name: 'Process Purchase Order', basic: false },
                { _id: FinanceSecurityRight.ApprovePurchaseOrder, name: 'Approve Purchase Order', basic: false },

            ] as SecurityRight<FinanceSecurityRight>[]
        );
    }




}
